<template>
    <div class="blog-comment">
        <div class="blog-comment__title">评论</div>
        <div class="blog-comment__form">
            <app-comment :hostId="hostId" @success="handleCommentSuccess"/>
        </div>
        <app-comment-list class="blog-comment__list"
                          :hostId="hostId"
                          ref="commentList"
                          @comment-success="handleCommentSuccess"
        />
    </div>
</template>

<script>
    import AppComment from '@components/AppComment'
    import AppCommentList from '@components/AppCommentList'

    export default {
        name: "BlogComment",
        props: {
            data: {
                type: Object,
                default() {
                    return {}
                }
            }
        },
        computed: {
            hostId() {
                const {data} = this
                const {id} = data || {}
                return id
            }
        },
        methods: {
            handleCommentSuccess() {
                this.$nextTick(() => {
                    console.log(this.$refs['commentList'])
                    if (this.$refs['commentList']) {
                        this.$refs['commentList'].refresh()
                    }
                })
            }
        },
        components: {
            AppCommentList,
            AppComment
        }
    }
</script>

<style lang="scss">
    @import "@assets/styles/varibles.scss";
    @import "@assets/styles/mixins.scss";

    .blog-comment {
        &__title {
            font-size: $fontSizeMD;
            text-align: center;
            color: $secondaryTextColor;
            color: var(--secondaryTextColor);
            @include transition-colors;
        }

        &__list {
            margin-top: $paddingMD;
        }
    }

</style>